import {API} from '../../networking/http'
import {SessionsList} from '../class-session/types'
import {QueryMethod} from '../helpers/types'

export type GetVenueClassSessionsByDateParams = undefined
export type GetVenueClassSessionsByDateQueryParams = {
  date: number | string
  venueId: string
  memberId?: string
  classesIds: string[]
}

export type GetVenueClassSessionsByDateReturnType = SessionsList & {closestSessionTimeStamp?: number}
export type GetVenueClassSessionsByDateQuery = QueryMethod<
  GetVenueClassSessionsByDateParams,
  GetVenueClassSessionsByDateQueryParams,
  GetVenueClassSessionsByDateReturnType
>

export const makeGetClassSessionsByDateEndpoint = () => 'classesSlots/sessionsByDateList'

export const getVenueClassesSessionsByDateQuery: GetVenueClassSessionsByDateQuery = ({query}) => ({
  queryKey: ['getVenueInstructorsQuery', query],
  cacheTime: 1000 * 300,
  queryFn: ({queryKey: [_, config]}) =>
    API.get<GetVenueClassSessionsByDateQueryParams, GetVenueClassSessionsByDateReturnType>(
      makeGetClassSessionsByDateEndpoint(),
      {params: config},
    ).then((res) => res.data),
})
